// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u7Yb+","footerLinks":"Footer_footerLinks__r6Do1","footerLink":"Footer_footerLink__yXfQD"};